import endpoints from '../endpoints.ts';
import api from '../api/index.ts';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { HydratedUser } from '../types/compoundModels.ts';
import useIsAdmin from '../../hooks/useIsAdmin.ts';
import { useEffect } from 'react';

export const USER_QUERY_KEY = 'USER_QUERY_KEY';

const useReadOneById = (
  options?: Partial<UseQueryOptions<HydratedUser | null>>
) =>
  useQuery({
    queryKey: [USER_QUERY_KEY, endpoints.user.read.one.by.id()],
    queryFn: api.user.read.one.by.id,
    ...options,
  });

const useGetIsAdminById = (
  params: { customerLocationId: number },
  options?: Partial<
    UseQueryOptions<{ isSuperAdmin: boolean; isAdmin: boolean } | null>
  >
) => {
  const { setIsAdmin } = useIsAdmin();

  const query = useQuery({
    queryKey: [endpoints.user.get.isAdmin.by.userId(), params],
    queryFn: () => api.user.get.isAdmin.by.userId(params),
    enabled: Boolean(params.customerLocationId),
    ...options,
  });

  useEffect(() => {
    if (query.data)
      setIsAdmin(query.data ?? { isSuperAdmin: false, isAdmin: false });
  }, [query.data, setIsAdmin]);

  return query;
};

const userQueryHooks = {
  useReadOneById,
  useGetIsAdminById,
};

export default userQueryHooks;
